import { Breakpoint } from '~/lib/utils/breakpoint';
export const createVideoBanner = (els) => {
    const srcSmall = els.video.dataset.smSrc;
    const srcLarge = els.video.dataset.lgSrc;
    const posterSmall = els.video.dataset.smPoster;
    const posterLarge = els.video.dataset.lgPoster;
    if (!srcSmall || !srcLarge || !posterSmall || !posterLarge) {
        throw new Error('Missing video banner video source(s)');
    }
    let source = null;
    const updateSource = () => {
        if (innerWidth < Breakpoint.MD) {
            if (source === VideoSource.SMALL) {
                return;
            }
            source = VideoSource.SMALL;
            els.video.src = srcSmall;
            els.video.poster = posterSmall;
        }
        else {
            if (source === VideoSource.LARGE) {
                return;
            }
            source = VideoSource.LARGE;
            els.video.src = srcLarge;
            els.video.poster = posterLarge;
        }
    };
    const observer = new ResizeObserver(updateSource);
    observer.observe(els.main);
    const play = () => {
        els.toggleBtn.ariaLabel = 'Pause video';
        els.toggleBtn.dataset.action = 'pause';
        els.video.play();
    };
    const pause = () => {
        els.toggleBtn.ariaLabel = 'Play video';
        els.toggleBtn.dataset.action = 'play';
        els.video.pause();
    };
    const toggle = () => {
        if (els.video.paused) {
            play();
        }
        else {
            pause();
        }
    };
    els.video.addEventListener('play', play);
    els.video.addEventListener('pause', pause);
    els.toggleBtn.addEventListener('click', toggle);
    return {
        play,
        pause,
        toggle,
    };
};
const VideoSource = {
    SMALL: 0,
    LARGE: 1,
};
